class CallMethodAusterity {
    static instance;
    uniQueIndexs = new Set();

    constructor() {
        if (CallMethodAusterity.instance) return CallMethodAusterity.instance
        CallMethodAusterity.instance = this
    }
    callMethod() {
        const params = arguments
        if (params.length < 2 || this.uniQueIndexs.has(params[0])) return;
        this.uniQueIndexs.add(params[0])
        const [_, callback, ...args] = params
        callback(args);
    }
}

export default CallMethodAusterity
